import { render, staticRenderFns } from "./industryAnalyze.vue?vue&type=template&id=66806612&scoped=true"
import script from "./industryAnalyze.vue?vue&type=script&lang=js"
export * from "./industryAnalyze.vue?vue&type=script&lang=js"
import style0 from "./industryAnalyze.vue?vue&type=style&index=0&id=66806612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66806612",
  null
  
)

export default component.exports